import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { visualizerActions, uiActions } from '../../store';
import { useEffect, useState } from 'react';
import styles from './SurfaceMenuItem.module.css';
import plus from './assets/plus.svg';
import edit from './assets/edit.svg';
import block from './assets/block.png';


export default function SurfacesMenuItem({index,surface}) {
  const dispatch = useDispatch();
  const activeSurface = useSelector(state => state.visualizer.activeSurface);
  const appliedProducts = useSelector(state => state.visualizer.appliedProducts);
  const [surfacesList, setSurfacesList] = useState([]);

  const isActive = activeSurface == null ? false : activeSurface?.name === surface.name && activeSurface?.location === surface?.location;
  const applied = appliedProducts?.[surface.location]?.[surface.name];
  const showClearBtn = index > 0 && !!applied; 

  const setActiveSurface = (surface) => {
    console.log('surface', surface);

    // Bail if nothing to set
    if (!surface || !surface.name) {
      console.warn('setActiveSurface called without a valid surface:', surface);
      return;
    }

    dispatch(visualizerActions.setActiveSurface(surface));

    // Normalize names safely
    const surfaceName = String(surface.name).toLowerCase();
    const activeName = String(activeSurface?.name || '').toLowerCase();

    // Select matching parent product menu tab
    if (surfaceName.includes('wall')) {
      // Only switch to a wall tab if a wall isn't already active
      if (!activeName.includes('wall')) {
        dispatch(visualizerActions.setActiveProductMenuTab('wall color'));
      }
    } else {
      dispatch(visualizerActions.setActiveProductMenuTab('flooring'));
    }
  };


  const clearSurface = (surface) => {
     dispatch(visualizerActions.clearAppliedProductsBySurface({ 
        location:activeSurface.location,
        surface:activeSurface.name
    }));
     document.getElementById('chamViz').applyByFilter("", "", function (newSel, currentSelectedSurface) {
        if(surface == this.name)
          return -1
      });
  };

  return (
    <div
      key={`${surface.name}-${surface.location}`}
      onClick={() => setActiveSurface(surface)}
      className={`${styles.surfaceMenu} ${isActive ? styles.active : ''}`}
    >
      {applied ? (
        <div className={styles.groupDiv}>
          <div className={styles.titleSurface}>
            <p>{surface.name}</p>
            {showClearBtn && (
              <button className={styles.clear} type="button" onClick={() => clearSurface(surface.name)} aria-label={`Clear ${surface.name}`}>
                &#10006; 
              </button>
            )}
          </div>
          <div className={styles.prodDiv}>
          <div className={styles.prodGroup}> 
            <span><img src={edit} alt="edit surface" /></span>
            {applied.colorway.seriesID == 7973 ? (
                    <img
                        loading="lazy"
                        style={{
                            backgroundColor: applied.colorway.specifier.replace("COLOR(", "").replace(")", "")
                        }}
                        src={block}
                        alt={`Product - ${applied.colorway.id}`}
                    />
                ) : (
                    <img src={`https://renderfarm1.chameleonpower.com/cham/getImage.ashx?spec=${encodeURIComponent(applied.colorway.specifier)}&type=prod&extra=(focus=500)&Size=250`} width={77} height={77} />
                )}
          </div>
          <div>
            <p>{applied.colorway.name}</p>
            <p>{applied.colorway.color}</p>
             <p>{applied.colorway.warranty}</p>
          </div>
          </div>
        </div>
      ) : (
        <div className={styles.groupDivAlt}>
           <div className={styles.titleSurface}>
            <p>{surface.name}</p></div>
          <div className={styles.addProduct}>
            <span><img src={plus} alt="add surface" /></span></div>
        </div>
      )}
    </div>
  );

}